import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import useTrailPolylineCoordinates from '../../hooks/useTrailPolylineCoordinates';
import Polyline from '../Polyline';

type TrailPolylineProps = {
  trail: Pick<TrailSearchResult, 'ID' | 'polyline'>;
  /** Defaults to the trail ID; pass another to draw the same trail twice without a source id clash */
  uniqueId?: string;
};

// Keyed by `uniqueId` because react-map-gl fixes a Source's id on mount and throws if it changes, so a different trail
// needs a fresh Source.
const TrailPolyline = ({ trail, uniqueId = String(trail.ID) }: TrailPolylineProps) => {
  const coordinates = useTrailPolylineCoordinates(trail);

  return coordinates ? <Polyline coordinates={coordinates} key={uniqueId} uniqueId={uniqueId} /> : null;
};

export default TrailPolyline;
